(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pl-product-feature-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      root.querySelectorAll('[data-pl-tabs]').forEach((component) => {
        if (component.dataset.ready === 'true') return;
        component.dataset.ready = 'true';
        const tabs = Array.from(component.querySelectorAll('[role="tab"]'));
        const panels = Array.from(component.querySelectorAll('[role="tabpanel"]'));
        const activate = (tab, focus) => {
          tabs.forEach((item) => {
            const selected = item === tab;
            item.setAttribute('aria-selected', selected ? 'true' : 'false');
            item.tabIndex = selected ? 0 : -1;
          });
          panels.forEach((panel) => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
          if (focus) tab.focus();
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => activate(tab, false));
          tab.addEventListener('keydown', (event) => {
            let next = index;
            if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
            else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = tabs.length - 1;
            else return;
            event.preventDefault();
            activate(tabs[next], true);
          });
        });
      });
    };
    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
